import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  searchDateFrom,
  searchStore,
  name,
  contact_no,
  id,
  onlyWin,
  type,
) => {
  return await GET(
    `/admin/teen-patti/bid-history-roomwise?page=${currentPage || 1}&per_page=${perPage || 10}&name=${name || ""}&contact_no=${contact_no || ""}&from=${searchDateFrom || ""}&store_id=${searchStore || ""}&id=${id || ""}&only_win=${onlyWin || ""}&type=${type || ""}`,
    {},
    process.env.REACT_APP_TEEN_PATTI_BASE_URL,
  );
};
